import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './conserto_relogio.css';
import { assets } from "../assets/assets";
import { abrirOrcamentoWhats, trazerRodapePaginasProdutos, trazerTituloProdutos } from "../utils/utils";

const Presente = () => {

  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Presentes";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />
      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.presentePapelaria})` }}>
        <div className="servico-hero-overlay">
          <h1>Presentes</h1>
          {/* <p>Para quem procura por presentes</p>*/}
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloProdutos()}</h2>
        </article>

        {/* Aqui começa todo o conteudo */}
        {/* Seção de Grade de Produtos - Presentes e Papelaria */}
        <section className="acessorios-grid">

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.canetas} alt="" /></div>
            <h3>Canetas</h3>
            <p>Disponível para personalização com gravação a laser.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.chaveiroDiversos} alt="" /></div>
            <h3>Chaveiros</h3>
            <p>Disponível para personalização com gravação a laser.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.carteirasAcessorios} alt="" /></div>
            <h3>Carteiras</h3>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.placasHomenagem} alt="" /></div>
            <h3>Placas de homenagem</h3>
            <p>Disponível para personalização com gravação a laser.</p>
          </div>

        </section>

        {/* Aqui termina todo o conteudo */}

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasProdutos('presentes')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('presentes')}>
            Solicitar disponibilidade
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>

      </main>
      <Footer />
    </div>
  )
}

export default Presente;